import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel on component mount
    initMetaPixel();
  }, []);
  return <LandingPage data-id="element-0" />;
}